"use client";

import { c as _c } from "react/compiler-runtime";
import Image from "next/image";
import { useEffect, useState } from "react";
import useIsMobile from "@/hooks/use-mobile";
import { useAdressesFromGouv } from "@/hooks/useAdressesFromGouv";
import { useGeolocation } from "@/hooks/useGeolocalisation";
import { useClubsFiltersAdressesStore, useClubsFiltersOpenedStore, useClubsFiltersStore } from "@/stores/clubs-filters-store";
import NearMeIcon from "public/icons/near-me-icon.png";
import ClubFilterLocationItem from "./ClubFilterLocationItem";
export default function ClubFilterLocation() {
  const $ = _c(50);
  const isMobile = useIsMobile();
  const filterLocationOpened = useClubsFiltersOpenedStore(_temp);
  const setFiltersLocationOpened = useClubsFiltersOpenedStore(_temp2);
  const setFiltersLocationClosed = useClubsFiltersOpenedStore(_temp3);
  const filtersLocation = useClubsFiltersStore(_temp4);
  const setLocation = useClubsFiltersStore(_temp5);
  const clearLocation = useClubsFiltersStore(_temp6);
  const adresses = useClubsFiltersAdressesStore(_temp7);
  const {
    fetchAdresses
  } = useAdressesFromGouv();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {};
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    position,
    error,
    loading,
    getPosition
  } = useGeolocation(t0, true);
  const [inputValue, setInputValue] = useState("");
  let t1;
  if ($[1] !== filtersLocation.address || $[2] !== filtersLocation.city || $[3] !== filtersLocation.zipCode) {
    t1 = () => {
      const locationString = filtersLocation.address || filtersLocation.zipCode || filtersLocation.city ? `${filtersLocation.address} ${filtersLocation.zipCode} ${filtersLocation.city}`.trim() : "";
      setInputValue(locationString);
    };
    $[1] = filtersLocation.address;
    $[2] = filtersLocation.city;
    $[3] = filtersLocation.zipCode;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== filtersLocation) {
    t2 = [filtersLocation];
    $[5] = filtersLocation;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  useEffect(t1, t2);
  let t3;
  if ($[7] !== clearLocation || $[8] !== fetchAdresses) {
    t3 = value => {
      setInputValue(value);
      if (!value || value.trim() === "") {
        clearLocation();
      } else {
        fetchAdresses(value);
      }
    };
    $[7] = clearLocation;
    $[8] = fetchAdresses;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  const handleChange = t3;
  let t4;
  if ($[10] !== setFiltersLocationClosed || $[11] !== setLocation) {
    t4 = location => {
      setLocation(location);
      setInputValue(`${location.address} ${location.zipCode} ${location.city}`.trim());
      setFiltersLocationClosed();
    };
    $[10] = setFiltersLocationClosed;
    $[11] = setLocation;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  const handleLocationSelect = t4;
  let t5;
  if ($[13] !== getPosition) {
    t5 = async () => {
      ;
      try {
        await getPosition();
      } catch (t6) {
        const error_0 = t6;
        console.error("Erreur lors de la g\xE9olocalisation:", error_0);
      }
    };
    $[13] = getPosition;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  const handleNearMe = t5;
  let t6;
  let t7;
  if ($[15] !== fetchAdresses || $[16] !== position || $[17] !== setFiltersLocationClosed || $[18] !== setLocation) {
    t6 = () => {
      if (position) {
        const reverseGeocode = async () => {
          ;
          try {
            const locationData = await fetchAdresses("", position.latitude, position.longitude, true);
            if (locationData) {
              setLocation(locationData);
              setInputValue(`${locationData.address} ${locationData.zipCode} ${locationData.city}`.trim());
              setFiltersLocationClosed();
            }
          } catch (t8) {
            const error_1 = t8;
            console.error("Erreur lors du g\xE9ocodage inverse:", error_1);
          }
        };
        reverseGeocode();
      }
    };
    t7 = [position, fetchAdresses, setLocation, setFiltersLocationClosed];
    $[15] = fetchAdresses;
    $[16] = position;
    $[17] = setFiltersLocationClosed;
    $[18] = setLocation;
    $[19] = t6;
    $[20] = t7;
  } else {
    t6 = $[19];
    t7 = $[20];
  }
  useEffect(t6, t7);
  let t8;
  let t9;
  if ($[21] !== error) {
    t8 = () => {
      if (error) {
        console.error("Erreur de g\xE9olocalisation:", error);
        if (error.message?.includes("permission") || error.message?.includes("blocked")) {
          alert("Les permissions de g\xE9olocalisation ont \xE9t\xE9 bloqu\xE9es. Veuillez les r\xE9activer dans les param\xE8tres de votre navigateur (ic\xF4ne de r\xE9glage \xE0 c\xF4t\xE9 de l'URL) pour utiliser cette fonctionnalit\xE9.");
        } else {
          if (error.message?.includes("timeout")) {
            alert("La g\xE9olocalisation a pris trop de temps. Veuillez r\xE9essayer.");
          } else {
            alert(error.message);
          }
        }
      }
    };
    t9 = [error];
    $[21] = error;
    $[22] = t8;
    $[23] = t9;
  } else {
    t8 = $[22];
    t9 = $[23];
  }
  useEffect(t8, t9);
  const t10 = `relative w-[33%] ${isMobile ? "w-full" : "w-[33%]"}`;
  const t11 = `flex w-[100%] justify-between items-center hover:cursor-pointer ${isMobile ? "" : "px-4"}`;
  let t12;
  if ($[24] !== setFiltersLocationOpened) {
    t12 = () => setFiltersLocationOpened();
    $[24] = setFiltersLocationOpened;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  let t13;
  if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <p className="font-bold">Localisation du club</p>;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  let t14;
  if ($[27] !== handleChange) {
    t14 = e => handleChange(e.target.value);
    $[27] = handleChange;
    $[28] = t14;
  } else {
    t14 = $[28];
  }
  let t15;
  if ($[29] !== inputValue || $[30] !== t14) {
    t15 = <div className="flex flex-col justify-center items-start w-full">{t13}<input placeholder="Adresse, code postal, ville..." name="location" className="border-none m-0 p-0 !mt-0 h-auto w-full placeholder:text-sm placeholder:text-grey placeholder:not-italic text-sm bg-transparent focus:outline-none focus:ring-0 pl-0" type="text" onChange={t14} value={inputValue} /></div>;
    $[29] = inputValue;
    $[30] = t14;
    $[31] = t15;
  } else {
    t15 = $[31];
  }
  let t16;
  if ($[32] !== handleNearMe) {
    t16 = () => handleNearMe();
    $[32] = handleNearMe;
    $[33] = t16;
  } else {
    t16 = $[33];
  }
  const t17 = loading ? "opacity-50 cursor-not-allowed" : "cursor-pointer";
  let t18;
  if ($[34] !== t16 || $[35] !== t17) {
    t18 = <Image src={NearMeIcon} alt="Pin" width={20} height={20} onClick={t16} className={t17} />;
    $[34] = t16;
    $[35] = t17;
    $[36] = t18;
  } else {
    t18 = $[36];
  }
  let t19;
  if ($[37] !== t11 || $[38] !== t12 || $[39] !== t15 || $[40] !== t18) {
    t19 = <div className={t11} onClick={t12}>{t15}{t18}</div>;
    $[37] = t11;
    $[38] = t12;
    $[39] = t15;
    $[40] = t18;
    $[41] = t19;
  } else {
    t19 = $[41];
  }
  let t20;
  if ($[42] !== adresses || $[43] !== filterLocationOpened || $[44] !== handleLocationSelect) {
    t20 = filterLocationOpened && <div className="absolute top-[60px] bg-white z-[1000] w-[100%] h-[auto] border border-light-grey rounded-[5px] my-2 shadow-md">{adresses.slice(0, 5).map((address, index) => <ClubFilterLocationItem key={`${address.properties.name}-${address.properties.postcode}-${address.properties.city}-${index}`} location={{
        address: address.properties.name,
        zipCode: address.properties.postcode,
        city: address.properties.city,
        latitude: address.geometry.coordinates[1],
        longitude: address.geometry.coordinates[0]
      }} onSelect={handleLocationSelect} />)}</div>;
    $[42] = adresses;
    $[43] = filterLocationOpened;
    $[44] = handleLocationSelect;
    $[45] = t20;
  } else {
    t20 = $[45];
  }
  let t21;
  if ($[46] !== t10 || $[47] !== t19 || $[48] !== t20) {
    t21 = <div className={t10}>{t19}{t20}</div>;
    $[46] = t10;
    $[47] = t19;
    $[48] = t20;
    $[49] = t21;
  } else {
    t21 = $[49];
  }
  return t21;
}
function _temp7(state_5) {
  return state_5.adresses;
}
function _temp6(state_4) {
  return state_4.clearLocation;
}
function _temp5(state_3) {
  return state_3.setLocation;
}
function _temp4(state_2) {
  return state_2.location;
}
function _temp3(state_1) {
  return state_1.setFiltersClosed;
}
function _temp2(state_0) {
  return state_0.setFilterLocationOpened;
}
function _temp(state) {
  return state.locationOpened;
}